import { createSelector } from '@ngrx/store'

export const getFormPostprocessorState = createSelector(
  (state: any) => state.formPostprocessors,
  (state: any) => state.get('list'),
)

export const getCreateFormPostprocessorState = createSelector(
  (state: any) => state.formPostprocessors,
  (state: any) => state.get('create'),
)

export const getUpdateFormPostprocessorState = createSelector(
  (state: any) => state.formPostprocessors,
  (state: any) => state.get('update'),
)
